import { useContext, useEffect, useState } from "react";
import TextWithCheckboxField from "../../../../components/textWithCheckboxField/textWithCheckboxField";
import KrFormContext, { KrFormContextEndangeredAreaType, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext";
import { TextWithCheckBoxFieldProps } from "../../../../components/textWithCheckboxField/types/textWithCheckboxFieldProps";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { PatternType } from "../../../../contexts/types/card";
import { createConfigValidation } from "../../../../helpers/validation/validation";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KRTZFieldDict } from "../../shared/commentsSidebar/fieldDict";

const ObservationInstructions = (props: FormSectionProps) => {
    const [pristine, setPristine] = useState(true);
    const [errorTipText, setErrorTipText] = useState("");
    const [reload, setReload] = useState(false);
    const DEFAULT_VALUE = 'Obserwacje powinny być prowadzone nie rzadziej niż raz na 3 lata.';
    const title = 'Wskazania dotyczące obserwacji';

    const isChecked = (value: string | undefined | null) => {
        return value === undefined || value === "" || value === DEFAULT_VALUE || value == null;
    }

    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextEndangeredAreaType;
    const [wskazania, setWskazania] = useState<boolean>(isChecked(krForm.endangeredAreaAttributes?.wskazania));

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["wskazania"]
            if (errorMsg !== '') {
                setErrorTipText(errorMsg);
                setReload(!reload);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const setValue = (value: any) => {
        if (krForm && krForm.endangeredAreaAttributes) {
            setkrForm({...krForm, endangeredAreaAttributes: {...krForm.endangeredAreaAttributes, wskazania: value}});
        }
    }

    const focusChange = () => {
        if (wskazania) {
            setValue("");
            setWskazania(!wskazania);
        }
    }

    const textWithCheckboxProps: TextWithCheckBoxFieldProps = {
        textAreaProps: {
            labelName: title,
            textAreaPlaceholder: 'Dodaj opis',
            value: krForm.endangeredAreaAttributes?.wskazania,
            textareaSharedProps: {
                className: 'body-txt-large',
                style: { 
                    width: '100%',
                    minHeight: '70px'
                }
            },
            pristine: pristine,
            onFocusText: focusChange,
            onBlurText: (event: any) => { blurChange(event, wskazania) },
            setValue: setValue,
            configValidation: props.collectiveEdition ? undefined : createConfigValidation("wskazania"),
            validationError: krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false,
            tipText: errorTipText,
            reload: reload,
            disabled: !props.editMode,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KRTZFieldDict.wskObserw_wskazaniaDotObserwacji, "Wskazania dotyczące obserwacji", props.setNewCommentFieldDetails!),
            textareaRef: (node: any) => {getFieldRef(node, KRTZFieldDict.wskObserw_wskazaniaDotObserwacji, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KRTZFieldDict.wskObserw_wskazaniaDotObserwacji); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KRTZFieldDict.wskObserw_wskazaniaDotObserwacji,
            dynamicResize: true
        },
        checkBoxProps: {
            onChange: () => { checkboxChange(wskazania) },
            labelName: DEFAULT_VALUE,
            inputChecked: wskazania,
            disabled: !props.editMode
        }
    }

    const blurChange = (event: any, state: boolean) => {
        if (event.target.value == null || event.target.value === "") {
            if (krForm?.endangeredAreaAttributes) {
                if (!state) checkboxChange(state);
            }
        }
    }

    const checkboxChange = (state: boolean) => {
        const newValue = state ? '' : DEFAULT_VALUE;
        setValue(newValue);
        setWskazania(!state);
        setPristine(false);
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKRTZEum.ObservationInstructions, props.getMapForNavScroll!) }>
                {`${props.version === PatternType.P2007 ? 3 : 4}. ${title}`}</h2>
            {props.collectiveEdition ? <CollectiveSelectField top={true} value={krForm.endangeredAreaAttributes?.wskazania} isAuto={false} title={"Wskazania dotyczące obserwacji"}
                forms={props.forms} keyName={CollectivePreviewKey.wskazania} actions={props.actions} single={true}
                setActions={props.setActions} onDelete={props.onDelete}>
                <TextWithCheckboxField {...textWithCheckboxProps} />
            </CollectiveSelectField> :
                <TextWithCheckboxField {...textWithCheckboxProps} />
            }
        </>
    )
}

export default ObservationInstructions;
